import { useState } from 'react';
import logoImage from '../assets/Monkey_logo_.png';
import './EmailPreview.css';

const EMAIL_TYPES = {
  BIKE: 'bike',
  ACTIVITY: 'activity',
};

const EmailPreview = () => {
  const [language, setLanguage] = useState('es');
  const [emailType, setEmailType] = useState(EMAIL_TYPES.BIKE);

  // Datos mockeados de una reserva de bicicletas
  const mockBookingData = {
    bookingId: 'BK-2024-001234',
    bookingReference: 'BR-2024-001234',
    customerInfo: {
      name: 'Juan Pérez García',
      email: 'juan.perez@example.com',
      phone: '+34 612 345 678',
      dni: '12345678A'
    },
    dates: {
      start: new Date('2024-07-15T10:00:00'),
      end: new Date('2024-07-20T18:00:00')
    },
    deliveryType: 'HOTEL',
    hotelAddress: 'Hotel Playa, Calle del Mar 15, 07560 Cala Millor, Illes Balears',
    pricing: {
      durationInDays: 5,
      vehicles: {
        items: [
          {
            brand: 'Trek',
            model: 'Mountain Bike Pro',
            size: 'M',
            serialNumber: 'TRK-2024-001',
            price: 120.00,
            imageUrl: 'https://via.placeholder.com/300x200?text=Mountain+Bike'
          },
          {
            brand: 'Specialized',
            model: 'Road Bike Elite',
            size: 'L',
            serialNumber: 'SPZ-2024-002',
            price: 150.00,
            imageUrl: 'https://via.placeholder.com/300x200?text=Road+Bike'
          }
        ],
        total: 270.00
      },
      accessories: {
        items: [
          {
            name: 'Casco de Seguridad',
            description: 'Casco certificado con ventilación',
            category: 'HELMET',
            priceType: 'FIXED',
            price: 15.00,
            imageUrl: 'https://via.placeholder.com/200x150?text=Casco'
          },
          {
            name: 'Candado de Seguridad',
            description: 'Candado de acero reforzado',
            category: 'LOCK',
            priceType: 'FIXED',
            price: 10.00,
            imageUrl: 'https://via.placeholder.com/200x150?text=Candado'
          },
          {
            name: 'GPS Tracker',
            description: 'Localizador GPS con app móvil',
            category: 'GPS',
            priceType: 'DAILY',
            price: 5.00,
            imageUrl: 'https://via.placeholder.com/200x150?text=GPS'
          }
        ],
        total: 50.00
      },
      deliveryCost: 25.00,
      grandTotal: 345.00
    }
  };

  // Datos mockeados de una reserva de actividad (Buggies, Parasailing, Jet ski)
  const mockActivityBookingData = {
    bookingId: 'ACT-2024-005678',
    bookingReference: 'AR-2024-005678',
    customerInfo: {
      name: 'María López Sánchez',
      email: 'maria.lopez@example.com',
      phone: '+34 698 112 233',
      dni: '87654321B'
    },
    activity: {
      name: 'Buggies',
      businessGroup: 'BUGGY',
      date: new Date('2024-08-10'),
      startTime: '10:00',
      endTime: '11:30',
      durationMinutes: 90,
      meetingPoint: 'Oficina Cala Millor, Carrer Arenal 6'
    },
    lines: [
      { variantName: 'Buggy 2 plazas', units: 1, unitPrice: 120.00, subtotal: 120.00 },
      { variantName: 'Buggy 4 plazas', units: 2, unitPrice: 180.00, subtotal: 360.00 }
    ],
    extras: [
      { label: 'Acompañante monitor', amount: 50.00 },
      { label: 'Seguro (no reembolsable)', amount: 20.00 }
    ],
    subtotalLines: 480.00,
    subtotalExtras: 70.00,
    total: 550.00
  };

  // Traducciones
  const translations = {
    es: {
      title: 'Tu reserva ha sido confirmada',
      bookingConfirmed: 'Reserva Confirmada',
      customerInfo: 'Información del Cliente',
      name: 'Nombre',
      email: 'Email',
      phone: 'Teléfono',
      dni: 'DNI',
      bookingDates: 'Fechas de la Reserva',
      pickupDate: 'Fecha de Recogida',
      returnDate: 'Fecha de Devolución',
      duration: 'Duración',
      day: 'día',
      days: 'días',
      selectedBikes: 'Bicicletas Seleccionadas',
      selectedAccessories: 'Accesorios Seleccionados',
      deliveryInfo: 'Información de Entrega',
      deliveryType: 'Tipo de entrega',
      homeDelivery: 'Entrega a domicilio',
      storePickup: 'Recogida en tienda',
      hotelDelivery: 'Entrega en hotel',
      deliveryCost: 'Coste de entrega',
      deliveryAddress: 'Dirección de entrega',
      storeAddress: 'Dirección de la tienda',
      viewOnMaps: 'Ver en Google Maps',
      pricingSummary: 'Resumen de Precios',
      bikes: 'Bicicletas',
      accessories: 'Accesorios',
      totalBooking: 'Total de la Reserva',
      vatIncluded: 'IVA incluido',
      storeHours: 'Horario de la Tienda',
      mondayFriday: 'Lunes - Viernes',
      saturday: 'Sábados',
      sunday: 'Domingos',
      holidays: 'Festivos',
      importantInfo: 'Información Importante',
      importantPoints: [
        'Llega 10 minutos antes de tu hora de recogida',
        'Presenta tu DNI en la recogida de la bicicleta',
        'Verifica el estado de la bicicleta antes de salir',
        'Devuelve la bicicleta en el mismo estado',
        'Contacta con nosotros si tienes alguna duda',
        'Respetamos el horario de la tienda para recogidas y devoluciones'
      ],
      thanks: 'Gracias por elegir Bike Rent Mallorca',
      contactUs: 'Para cualquier consulta, contacta con nosotros',
      disclaimer: 'Este email ha sido generado automáticamente. Por favor, no respondas a este mensaje.',
      size: 'Talla',
      serialNumber: 'Número de serie',
      price: 'Precio',
      category: 'Categoría',
      type: 'Tipo',
      daily: 'Diario',
      fixed: 'Fijo',
      // Actividad
      activityTitle: 'Tu reserva de actividad ha sido confirmada',
      tourSelected: 'Actividad y horario',
      activityName: 'Actividad',
      dateAndTime: 'Fecha y horario',
      date: 'Fecha',
      time: 'Hora',
      duration: 'Duración',
      meetingPoint: 'Punto de encuentro',
      bookingDetails: 'Detalle de la reserva',
      lineItem: 'Línea',
      variantName: 'Variante',
      units: 'Unidades',
      unitPrice: 'Precio unit.',
      lineSubtotal: 'Subtotal',
      extras: 'Suplementos',
      subtotalLines: 'Subtotal actividad',
      subtotalExtras: 'Subtotal suplementos',
      totalBookingActivity: 'Total de la reserva',
      importantInfoActivity: 'Información importante',
      importantPointsActivity: [
        'Presenta tu reserva (referencia o DNI) en el punto de encuentro',
        'Llega al menos 15 minutos antes de la hora de inicio',
        'Cumple los requisitos de edad y documentación según la actividad',
        'Contacta con nosotros si necesitas cancelar o modificar',
        'Para cualquier consulta, escríbenos a info@bikerentmallorca.com'
      ]
    },
    en: {
      title: 'Your booking has been confirmed',
      bookingConfirmed: 'Booking Confirmed',
      customerInfo: 'Customer Information',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      dni: 'ID',
      bookingDates: 'Booking Dates',
      pickupDate: 'Pickup Date',
      returnDate: 'Return Date',
      duration: 'Duration',
      day: 'day',
      days: 'days',
      selectedBikes: 'Selected Bikes',
      selectedAccessories: 'Selected Accessories',
      deliveryInfo: 'Delivery Information',
      deliveryType: 'Delivery type',
      homeDelivery: 'Home delivery',
      storePickup: 'Store pickup',
      hotelDelivery: 'Hotel delivery',
      deliveryCost: 'Delivery cost',
      deliveryAddress: 'Delivery address',
      storeAddress: 'Store address',
      viewOnMaps: 'View on Google Maps',
      pricingSummary: 'Pricing Summary',
      bikes: 'Bikes',
      accessories: 'Accessories',
      totalBooking: 'Total Booking',
      vatIncluded: 'VAT included',
      storeHours: 'Store Hours',
      mondayFriday: 'Monday - Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      holidays: 'Holidays',
      importantInfo: 'Important Information',
      importantPoints: [
        'Arrive 10 minutes before your pickup time',
        'Present your ID when picking up the bike',
        'Check the bike condition before leaving',
        'Return the bike in the same condition',
        'Contact us if you have any questions',
        'We respect store hours for pickups and returns'
      ],
      thanks: 'Thank you for choosing Bike Rental',
      contactUs: 'For any inquiries, please contact us',
      disclaimer: 'This email was automatically generated. Please do not reply to this message.',
      size: 'Size',
      serialNumber: 'Serial number',
      price: 'Price',
      category: 'Category',
      type: 'Type',
      daily: 'Daily',
      fixed: 'Fixed',
      activityTitle: 'Your activity booking has been confirmed',
      tourSelected: 'Activity and schedule',
      activityName: 'Activity',
      dateAndTime: 'Date and time',
      date: 'Date',
      time: 'Time',
      duration: 'Duration',
      meetingPoint: 'Meeting point',
      bookingDetails: 'Booking details',
      lineItem: 'Line',
      variantName: 'Variant',
      units: 'Units',
      unitPrice: 'Unit price',
      lineSubtotal: 'Subtotal',
      extras: 'Extras',
      subtotalLines: 'Activity subtotal',
      subtotalExtras: 'Extras subtotal',
      totalBookingActivity: 'Total booking',
      importantInfoActivity: 'Important information',
      importantPointsActivity: [
        'Present your booking (reference or ID) at the meeting point',
        'Arrive at least 15 minutes before the start time',
        'Meet age and documentation requirements for the activity',
        'Contact us if you need to cancel or modify',
        'For any inquiries, email us at info@bikerentmallorca.com'
      ]
    },
    de: {
      title: 'Ihre Buchung wurde bestätigt',
      bookingConfirmed: 'Buchung Bestätigt',
      customerInfo: 'Kundeninformationen',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      dni: 'Ausweis',
      bookingDates: 'Buchungsdaten',
      pickupDate: 'Abholtermin',
      returnDate: 'Rückgabedatum',
      duration: 'Dauer',
      day: 'Tag',
      days: 'Tage',
      selectedBikes: 'Ausgewählte Fahrräder',
      selectedAccessories: 'Ausgewählte Zubehörteile',
      deliveryInfo: 'Lieferinformationen',
      deliveryType: 'Lieferart',
      homeDelivery: 'Hauslieferung',
      storePickup: 'Abholung im Geschäft',
      hotelDelivery: 'Hotel-Lieferung',
      deliveryCost: 'Lieferkosten',
      deliveryAddress: 'Lieferadresse',
      storeAddress: 'Geschäftsadresse',
      viewOnMaps: 'Auf Google Maps anzeigen',
      pricingSummary: 'Preiszusammenfassung',
      bikes: 'Fahrräder',
      accessories: 'Zubehör',
      totalBooking: 'Gesamtbuchung',
      vatIncluded: 'MwSt. inklusive',
      storeHours: 'Öffnungszeiten',
      mondayFriday: 'Montag - Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
      holidays: 'Feiertage',
      importantInfo: 'Wichtige Informationen',
      importantPoints: [
        'Kommen Sie 10 Minuten vor Ihrer Abholzeit an',
        'Zeigen Sie Ihren Ausweis bei der Abholung des Fahrrads vor',
        'Überprüfen Sie den Zustand des Fahrrads vor dem Verlassen',
        'Geben Sie das Fahrrad im gleichen Zustand zurück',
        'Kontaktieren Sie uns bei Fragen',
        'Wir respektieren die Öffnungszeiten für Abholungen und Rückgaben'
      ],
      thanks: 'Vielen Dank, dass Sie Bike Rental gewählt haben',
      contactUs: 'Bei Fragen kontaktieren Sie uns bitte',
      disclaimer: 'Diese E-Mail wurde automatisch generiert. Bitte antworten Sie nicht auf diese Nachricht.',
      size: 'Größe',
      serialNumber: 'Seriennummer',
      price: 'Preis',
      category: 'Kategorie',
      type: 'Typ',
      daily: 'Täglich',
      fixed: 'Fest',
      activityTitle: 'Ihre Aktivitätsbuchung wurde bestätigt',
      tourSelected: 'Aktivität und Zeitplan',
      activityName: 'Aktivität',
      dateAndTime: 'Datum und Uhrzeit',
      date: 'Datum',
      time: 'Uhrzeit',
      duration: 'Dauer',
      meetingPoint: 'Treffpunkt',
      bookingDetails: 'Buchungsdetails',
      lineItem: 'Position',
      variantName: 'Variante',
      units: 'Anzahl',
      unitPrice: 'Stückpreis',
      lineSubtotal: 'Zwischensumme',
      extras: 'Zusätze',
      subtotalLines: 'Aktivität Zwischensumme',
      subtotalExtras: 'Zusätze Zwischensumme',
      totalBookingActivity: 'Gesamtbuchung',
      importantInfoActivity: 'Wichtige Informationen',
      importantPointsActivity: [
        'Zeigen Sie Ihre Buchung (Referenz oder Ausweis) am Treffpunkt vor',
        'Kommen Sie mindestens 15 Minuten vor Beginn an',
        'Erfüllen Sie die Alters- und Dokumentenanforderungen für die Aktivität',
        'Kontaktieren Sie uns bei Stornierung oder Änderung',
        'Bei Fragen schreiben Sie uns an info@bikerentmallorca.com'
      ]
    }
  };

  const t = translations[language] || translations.es;

  // Formatear fechas según el idioma
  const localeMap = { es: 'es-ES', en: 'en-US', de: 'de-DE' };
  const locale = localeMap[language] || 'es-ES';
  
  const startDate = mockBookingData.dates.start.toLocaleDateString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const endDate = mockBookingData.dates.end.toLocaleDateString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const getDeliveryTypeText = () => {
    switch (mockBookingData.deliveryType) {
      case 'DELIVERY':
      case 'HOTEL':
        return t.homeDelivery;
      case 'PICKUP':
        return t.storePickup;
      default:
        return t.storePickup;
    }
  };

  const generateGoogleMapsLink = (address) => {
    if (!address) return null;
    const encodedAddress = encodeURIComponent(address);
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  };

  const activityDateFormatted = mockActivityBookingData.activity.date.toLocaleDateString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const isActivityEmail = emailType === EMAIL_TYPES.ACTIVITY;
  const customerInfo = isActivityEmail ? mockActivityBookingData.customerInfo : mockBookingData.customerInfo;
  const bookingRef = isActivityEmail ? mockActivityBookingData.bookingReference : (mockBookingData.bookingReference || mockBookingData.bookingId);

  return (
    <div className="email-preview-page">
      <div className="email-preview-controls">
        <h1>Vista Previa del Correo de Confirmación</h1>
        <div className="email-preview-selectors">
          <div className="language-selector">
            <label>Tipo de correo:</label>
            <select value={emailType} onChange={(e) => setEmailType(e.target.value)}>
              <option value={EMAIL_TYPES.BIKE}>Reserva bicicletas</option>
              <option value={EMAIL_TYPES.ACTIVITY}>Reserva actividad (Buggies / Parasailing / Jet ski)</option>
            </select>
          </div>
          <div className="language-selector">
            <label>Idioma:</label>
            <select value={language} onChange={(e) => setLanguage(e.target.value)}>
              <option value="es">Español</option>
              <option value="en">English</option>
              <option value="de">Deutsch</option>
            </select>
          </div>
        </div>
      </div>

      <div className="email-preview-container">
        <div className="email-container">
          {/* Header */}
          <div className="email-header">
            <img src={logoImage} alt="Monkey Bike" className="email-header-logo" />
            <p>{isActivityEmail ? t.activityTitle : t.title}</p>
          </div>
          
          {/* Booking ID */}
          <div className="email-booking-id">
            <h2>{t.bookingConfirmed}</h2>
            <p>#{bookingRef}</p>
          </div>
          
          {/* Customer Information */}
          <div className="email-section">
            <h3>👤 {t.customerInfo}</h3>
            <div className="email-customer-info">
              <div className="email-info-item">
                <strong>{t.name}:</strong>
                <span>{customerInfo.name}</span>
              </div>
              <div className="email-info-item">
                <strong>{t.email}:</strong>
                <span>{customerInfo.email}</span>
              </div>
              <div className="email-info-item">
                <strong>{t.phone}:</strong>
                <span>{customerInfo.phone}</span>
              </div>
              <div className="email-info-item">
                <strong>{t.dni}:</strong>
                <span>{customerInfo.dni}</span>
              </div>
            </div>
          </div>
          
          {isActivityEmail ? (
            <>
              {/* Actividad: Tour y horario */}
              <div className="email-section">
                <h3>🎯 {t.tourSelected}</h3>
                <div className="email-activity-tour">
                  <div className="email-info-item">
                    <strong>{t.activityName}:</strong>
                    <span>{mockActivityBookingData.activity.name}</span>
                  </div>
                  <div className="email-info-item">
                    <strong>{t.date}:</strong>
                    <span>{activityDateFormatted}</span>
                  </div>
                  <div className="email-info-item">
                    <strong>{t.time}:</strong>
                    <span>{mockActivityBookingData.activity.startTime} - {mockActivityBookingData.activity.endTime}</span>
                  </div>
                  <div className="email-info-item">
                    <strong>{t.duration}:</strong>
                    <span>{mockActivityBookingData.activity.durationMinutes} min</span>
                  </div>
                  <div className="email-info-item">
                    <strong>{t.meetingPoint}:</strong>
                    <span>{mockActivityBookingData.activity.meetingPoint}</span>
                  </div>
                  {generateGoogleMapsLink(mockActivityBookingData.activity.meetingPoint) && (
                    <div className="email-info-item">
                      <a
                        href={generateGoogleMapsLink(mockActivityBookingData.activity.meetingPoint)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="email-maps-link"
                      >
                        🗺️ {t.viewOnMaps}
                      </a>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Actividad: Detalle de líneas y precios */}
              <div className="email-section">
                <h3>📋 {t.bookingDetails}</h3>
                <div className="email-activity-lines">
                  {mockActivityBookingData.lines.map((line, index) => (
                    <div key={index} className="email-activity-line-card">
                      <div className="email-activity-line-header">
                        <span className="email-activity-line-name">{line.variantName}</span>
                        <span className="email-activity-line-subtotal">€{line.subtotal.toFixed(2)}</span>
                      </div>
                      <div className="email-activity-line-detail">
                        {line.units} × €{line.unitPrice.toFixed(2)} = €{line.subtotal.toFixed(2)}
                      </div>
                    </div>
                  ))}
                  {mockActivityBookingData.extras && mockActivityBookingData.extras.length > 0 && (
                    <>
                      <div className="email-activity-extras-title">{t.extras}</div>
                      {mockActivityBookingData.extras.map((extra, index) => (
                        <div key={index} className="email-activity-line-card email-activity-extra">
                          <div className="email-activity-line-header">
                            <span className="email-activity-line-name">{extra.label}</span>
                            <span className="email-activity-line-subtotal">€{extra.amount.toFixed(2)}</span>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
              
              {/* Actividad: Resumen de precios */}
              <div className="email-section">
                <h3>💰 {t.pricingSummary}</h3>
                <div className="email-pricing-summary">
                  <div className="email-pricing-item">
                    <span>{t.subtotalLines}</span>
                    <span>€{mockActivityBookingData.subtotalLines.toFixed(2)}</span>
                  </div>
                  {mockActivityBookingData.subtotalExtras > 0 && (
                    <div className="email-pricing-item">
                      <span>{t.subtotalExtras}</span>
                      <span>€{mockActivityBookingData.subtotalExtras.toFixed(2)}</span>
                    </div>
                  )}
                  <div className="email-pricing-item email-pricing-total">
                    <span>{t.totalBookingActivity} <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#9CA3AF' }}>({t.vatIncluded})</span></span>
                    <span className="email-total">€{mockActivityBookingData.total.toFixed(2)}</span>
                  </div>
                </div>
              </div>
              
              {/* Actividad: Información importante */}
              <div className="email-important-info">
                <h3>📋 {t.importantInfoActivity}</h3>
                <ul>
                  {(t.importantPointsActivity || []).map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
              </div>
            </>
          ) : (
            <>
              {/* Dates */}
              <div className="email-section">
                <h3>📅 {t.bookingDates}</h3>
                <div className="email-dates-info">
                  <div className="email-date-card">
                    <h4>{t.pickupDate}</h4>
                    <p>{startDate}</p>
                  </div>
                  <div className="email-date-card">
                    <h4>{t.returnDate}</h4>
                    <p>{endDate}</p>
                  </div>
                </div>
                <p className="email-duration">
                  {t.duration}: {mockBookingData.pricing.durationInDays} {mockBookingData.pricing.durationInDays > 1 ? t.days : t.day}
                </p>
              </div>
              
              {/* Vehicles */}
              <div className="email-section">
                <h3>🚲 {t.selectedBikes}</h3>
                <div className="email-vehicles-grid">
                  {mockBookingData.pricing.vehicles.items.map((vehicle, index) => (
                    <div key={index} className="email-vehicle-card">
                      {vehicle.imageUrl && (
                        <div className="email-vehicle-image">
                          <img src={vehicle.imageUrl} alt={vehicle.model} />
                        </div>
                      )}
                      <div className="email-vehicle-info">
                        <h4>{vehicle.brand} {vehicle.model}</h4>
                        <p><strong>{t.size}:</strong> {vehicle.size}</p>
                        <p><strong>{t.serialNumber}:</strong> {vehicle.serialNumber}</p>
                        <p><strong>{t.price}:</strong> €{vehicle.price.toFixed(2)}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Accessories */}
              {mockBookingData.pricing.accessories.items.length > 0 && (
                <div className="email-section">
                  <h3>🎒 {t.selectedAccessories}</h3>
                  <div className="email-accessories-grid">
                    {mockBookingData.pricing.accessories.items.map((accessory, index) => (
                      <div key={index} className="email-accessory-card">
                        {accessory.imageUrl && (
                          <div className="email-accessory-image">
                            <img src={accessory.imageUrl} alt={accessory.name} />
                          </div>
                        )}
                        <div className="email-accessory-info">
                          <h4>{accessory.name}</h4>
                          {accessory.description && (
                            <p className="email-accessory-description">{accessory.description}</p>
                          )}
                          <p><strong>{t.category}:</strong> {accessory.category}</p>
                          <p><strong>{t.type}:</strong> {accessory.priceType === 'DAILY' ? t.daily : t.fixed}</p>
                          <p><strong>{t.price}:</strong> €{accessory.price.toFixed(2)}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Delivery Information */}
              <div className="email-section">
                <h3>🚚 {t.deliveryInfo}</h3>
                <div className="email-delivery-info">
                  <div className="email-info-item">
                    <strong>{t.deliveryType}:</strong>
                    <span>{getDeliveryTypeText()}</span>
                  </div>
                  {(mockBookingData.deliveryType === 'DELIVERY' || mockBookingData.deliveryType === 'HOTEL') && (
                    <>
                      {mockBookingData.hotelAddress && (
                        <>
                          <div className="email-info-item">
                            <strong>{t.deliveryAddress}:</strong>
                            <span>{mockBookingData.hotelAddress}</span>
                          </div>
                          {generateGoogleMapsLink(mockBookingData.hotelAddress) && (
                            <div className="email-info-item">
                              <a 
                                href={generateGoogleMapsLink(mockBookingData.hotelAddress)} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="email-maps-link"
                              >
                                🗺️ {t.viewOnMaps}
                              </a>
                            </div>
                          )}
                        </>
                      )}
                      {mockBookingData.pricing.deliveryCost > 0 && (
                        <div className="email-info-item">
                          <strong>{t.deliveryCost}:</strong>
                          <span>€{mockBookingData.pricing.deliveryCost.toFixed(2)}</span>
                        </div>
                      )}
                    </>
                  )}
                  {mockBookingData.deliveryType === 'PICKUP' && (
                    <>
                      <div className="email-info-item">
                        <strong>{t.storeAddress}:</strong>
                        <span>Carrer Arenal, 6, 07560 Cala Millor, Illes Balears</span>
                      </div>
                      <div className="email-info-item">
                        <a 
                          href="https://maps.app.goo.gl/rr4JmLFCat9CpUpr6" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="email-maps-link"
                        >
                          🗺️ {t.viewOnMaps}
                        </a>
                      </div>
                    </>
                  )}
                </div>
              </div>
              
              {/* Pricing Summary */}
              <div className="email-section">
                <h3>💰 {t.pricingSummary}</h3>
                <div className="email-pricing-summary">
                  <div className="email-pricing-item">
                    <span>{t.bikes} ({mockBookingData.pricing.durationInDays} {mockBookingData.pricing.durationInDays > 1 ? t.days : t.day})</span>
                    <span>€{mockBookingData.pricing.vehicles.total.toFixed(2)}</span>
                  </div>
                  {mockBookingData.pricing.accessories.total > 0 && (
                    <div className="email-pricing-item">
                      <span>{t.accessories}</span>
                      <span>€{mockBookingData.pricing.accessories.total.toFixed(2)}</span>
                    </div>
                  )}
                  {(mockBookingData.deliveryType === 'DELIVERY' || mockBookingData.deliveryType === 'HOTEL') && mockBookingData.pricing.deliveryCost > 0 && (
                    <div className="email-pricing-item">
                      <span>{t.homeDelivery}</span>
                      <span>€{mockBookingData.pricing.deliveryCost.toFixed(2)}</span>
                    </div>
                  )}
                  <div className="email-pricing-item email-pricing-total">
                    <span>{t.totalBooking} <span style={{fontSize: '14px', fontWeight: 'normal', color: '#9CA3AF'}}>({t.vatIncluded})</span></span>
                    <span className="email-total">€{mockBookingData.pricing.grandTotal.toFixed(2)}</span>
                  </div>
                </div>
              </div>
              
              {/* Store Hours */}
              <div className="email-store-hours">
                <h3>🕒 {t.storeHours}</h3>
                <div className="email-hours-grid">
                  <div className="email-hours-item">
                    <span className="email-day">{t.mondayFriday}</span>
                    <span className="email-time">09:00 - 18:00</span>
                  </div>
                  <div className="email-hours-item">
                    <span className="email-day">{t.saturday}</span>
                    <span className="email-time">09:00 - 17:00</span>
                  </div>
                  <div className="email-hours-item">
                    <span className="email-day">{t.sunday}</span>
                    <span className="email-time">10:00 - 16:00</span>
                  </div>
                  <div className="email-hours-item">
                    <span className="email-day">{t.holidays}</span>
                    <span className="email-time">10:00 - 16:00</span>
                  </div>
                </div>
              </div>
              
              {/* Important Information */}
              <div className="email-important-info">
                <h3>📋 {t.importantInfo}</h3>
                <ul>
                  {t.importantPoints.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
              </div>
            </>
          )}
          
          {/* Footer (común) */}
          <div className="email-footer">
            <p>{t.thanks}</p>
            <p>{t.contactUs}</p>
            <p><a href="mailto:info@bikerentmallorca.com">info@bikerentmallorca.com</a></p>
            <p className="email-disclaimer">
              {t.disclaimer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailPreview;

